<template>
  <div class="body">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Overpass:wght@300;600&family=Ubuntu:wght@400;500;700&display=swap" rel="stylesheet">
    <Top />
    <Editor />
    <Phones />
    <Laptop />
    <Footer />
  </div>
</template>

<script>
import Top from '../components/blogr/top/index.vue';
import Editor from '../components/blogr/Editor.vue';
import Phones from '../components/blogr/Phones.vue';
import Laptop from '../components/blogr/Laptop.vue';
import Footer from '../components/blogr/Footer.vue';

export default {
  name: 'Blogr',
  components: {
    Top,
    Editor,
    Phones,
    Laptop,
    Footer,
  },
};
</script>

<style src="../css/blogr/global.scss" lang="scss" />
<style lang="scss" scoped>

.body {
  --light-red: hsl(356, 100%, 66%);
  --very-light-red: hsl(355, 100%, 74%);
  --very-dark-blue: hsl(208, 49%, 24%);
  --white: hsl(0, 0%, 100%);
  --grayish-blue: hsl(240, 2%, 79%);
  --light-grayish-blue: hsl(0, 0%, 86%);
  --very-dark-grayish-blue: hsl(207, 13%, 34%);
  --very-dark-black-blue: hsl(240, 10%, 16%);
  --g-very-light-red: hsl(13, 100%, 72%);
  --g-light-red: hsl(353, 100%, 62%);
  --very-dark-gray-blue: hsl(237, 17%, 21%);
  --very-dark-desaturated-blue: hsl(237, 23%, 32%);

  --ff-alt: 'Overpass', sans-serif;
  --ff-default: 'Ubuntu', sans-serif;

  --border-radius: 0.5rem;

  /* spacing */
  --sm-spacer: 2rem;
  --bg-spacer: 4rem;

  /* breakpoints */
  $fonts-media: 40em;

  /* fonts */
  --fs-h0: 5rem;
  --fs-h1: 2rem;
  --fs-h2: 1.5rem;
  --fs-h3: 1rem;
  --fs-h4: 0.8rem;
  --fs-base: 0.7rem;
  --fw-100: 100;
  --fw-normal: 400;
  --fw-600: 600;
  --fw-700: 700;

  font-family: var(--ff-default);
  font-size: var(--fs-h3);
  text-align: center;

  @media (min-width: $fonts-media) {
    /* spacing */
    --sm-spacer: 3rem;
    --bg-spacer: 6rem;

    /* fonts */
    --fs-h0: 6rem;
    --fs-h1: 2.5rem;
    --fs-h2: 2rem;
    --fs-h3: 1.3rem;
    --fs-h4: 1rem;
    --fs-base: 0.9375rem;
  }
}

</style>
